export default __webpack_public_path__ + "static/media/CNo.45-0.4ef0a155.jpg";